import React from 'react';
import { Button, Grid } from 'ui';
import { TextField } from '../Field';
import { useController } from './hooks/useController';

export const AuthorizeWithPassword = (props) => {
  const {
    label,
    loading,
    onSubmit,
    submitText,
  } = props;
  const {
    control,
    handleSubmit,
  } = useController({ onSubmit });

  return (
    <Grid
      as="form"
      rowGap="1rem"
      id="authorizePasswordForm"
      onSubmit={handleSubmit}
    >
      <TextField
        autoFocus
        id="password"
        name="password"
        type="password"
        control={control}
        labelText={label}
      />
      <Button
        type="submit"
        colorScheme="green"
        isLoading={loading}
        form="authorizePasswordForm"
      >
        {submitText}
      </Button>
    </Grid>
  );
};
